import { useState, useCallback } from 'react';

export function useSafeKeyDown(handler) {
  const [isComposing, setIsComposing] = useState(false);

  const onCompositionStart = useCallback(() => {
    setIsComposing(true);
  }, []);

  const onCompositionEnd = useCallback(() => {
    setIsComposing(false);
  }, []);

  const onKeyDown = useCallback(
    (e) => {
      if (!isComposing) {
        handler(e);
      }
    },
    [isComposing, handler]
  );

  return {
    onKeyDown,
    onCompositionStart,
    onCompositionEnd,
  };
}
